window.addEventListener('load', () => {

	console.log('trudy is in the house - assets/custom.js')

	let oldScroll = 0;
	const navBar = document.getElementById('shopify-section-header');
	const filterMenu = document.getElementById('mobileFilterMenu')

	const menuOnScroll = () => {

		// FALSE if DOWN and TRUE if UP
		if (oldScroll > window.pageYOffset || oldScroll < 30) {
            // console.log("scroll UP")
			navBar.style.opacity = 1
			navBar.style.pointerEvents = 'auto'
			if(filterMenu){
				filterMenu.style.opacity = 1
				filterMenu.style.pointerEvents = 'auto'
			}

		} else {
            // console.log("scroll DOWN")
			navBar.style.opacity = 0
			navBar.style.pointerEvents = 'none'
			if (filterMenu) {
				filterMenu.style.opacity = 0
				filterMenu.style.pointerEvents = 'none'
			}
		}

		oldScroll = window.pageYOffset

	}

	window.addEventListener('scroll', (e) => { menuOnScroll(e) })
})